module.exports={
	"Form": "TestEditManifest",
	"Scope": "Test-Edit",
	"Descriptors":
	{
		"TestDetails.Name":
		{
			"Name": "Name",
			"Hash": "Test-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Test-Edit-Identity",
				"Group": "Test-Edit-Identity"
			}
		},
		"TestDetails.Description":
		{
			"Name": "Description",
			"Hash": "Test-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Test-Edit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Test-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.Active":
		{
			"Name": "Active",
			"Hash": "Test-Edit-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.Standalone":
		{
			"Name": "Standalone",
			"Hash": "Test-Edit-Standalone",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.Injectable":
		{
			"Name": "Injectable",
			"Hash": "Test-Edit-Injectable",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.Collection":
		{
			"Name": "Collection",
			"Hash": "Test-Edit-Collection",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.SmallQuantityExempt":
		{
			"Name": "Small Quantity Exempt",
			"Hash": "Test-Edit-SmallQuantityExempt",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.IDTest":
		{
			"Name": "IDTest",
			"Hash": "Test-Edit-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Test-Edit-DataAudit",
				"Group": "Test-Edit-DataAudit"
			}
		},
		"TestDetails.GUIDTest":
		{
			"Name": "GUIDTest",
			"Hash": "Test-Edit-GUIDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Test-Edit-DataAudit",
				"Group": "Test-Edit-DataAudit"
			}
		},
		"TestDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Test-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Test-Edit-DataAudit",
				"Group": "Test-Edit-DataAudit"
			}
		},
		"TestDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Test-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Test-Edit-DataAudit",
				"Group": "Test-Edit-DataAudit"
			}
		},
		"TestDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Test-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Test-Edit-DataAudit",
				"Group": "Test-Edit-DataAudit"
			}
		},
		"TestDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Test-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Test-Edit-DataAudit",
				"Group": "Test-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Test-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Test-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Test-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Test-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Test-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Test-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
